// extracted by mini-css-extract-plugin
export default {"reload":"tables_reload__KaHPF"};